import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdDocumentsOptions } from '@onefootprint/fetch-dashboard';
import type { Document, DocumentUpload } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import getDocumentId from '../utils/get-document-id';
import sortDocumentsAndUploads from '../utils/sort-documents';
import transformUploadsWithIsLatest from '../utils/transform-uploads-with-is-latest';
export type TransformedDocument = Omit<Document, 'uploads'> & {
  id: string;
  uploads: (DocumentUpload & {
    isLatest: boolean;
  })[];
};
const transformDocuments = (documents: Document[]): TransformedDocument[] => {
  // The dashboard can't play the selfie video yet, so its upload would show as a broken image.
  const shownDocuments = documents.map(doc => ({
    ...doc,
    uploads: doc.uploads.filter(upload => upload.side !== 'selfie_video')
  })).filter(doc => doc.uploads.length > 0);
  const sortedDocuments = sortDocumentsAndUploads(shownDocuments);
  const docsWithIsLatest = sortedDocuments.map(doc => ({
    ...doc,
    uploads: transformUploadsWithIsLatest(doc.uploads)
  }));
  const docsWithIds = docsWithIsLatest.map(document => ({
    ...document,
    id: getDocumentId(document)
  }));
  return docsWithIds;
};
const useDocuments = (id, seqno) => {
  const $ = _c(6);
  let t0;
  if ($[0] !== id || $[1] !== seqno) {
    t0 = getEntitiesByFpIdDocumentsOptions({
      path: {
        fpId: id
      },
      query: {
        seqno
      }
    });
    $[0] = id;
    $[1] = seqno;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = !!id;
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      select: transformDocuments
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useQuery(t2);
};
export { transformDocuments };
export default useDocuments;